// extracted by mini-css-extract-plugin
export default {"alerts":"Alerts_alerts__QL2oN","table":"Alerts_table__YOcbn"};